/* eslint-disable tailwindcss/no-custom-classname */
/* eslint-disable tailwindcss/no-arbitrary-value */
import classNames from 'classnames';
import { CmsImage } from '../../CmsImage/CmsImage';
import type {
  ProductGridCardImageFit,
  ProductGridCardImageFrame,
} from '../types';

type ProductGridCardImageProps = {
  imageUrl: string;
  imageAlt: string;
  imageFrame: ProductGridCardImageFrame;
  imageFit: ProductGridCardImageFit;
};

export const ProductGridCardImage = ({
  imageUrl,
  imageAlt,
  imageFrame,
  imageFit,
}: ProductGridCardImageProps) => (
  <div
    className={classNames(
      'overflow-hidden rounded-[6px] md:rounded-radius/button',
      imageFrame === 'framed' &&
        'border border-borders/default bg-gradient-to-b from-fill/card to-fill/alternative-1 p-[6px] md:p-spacing/padding/soft-8px',
    )}
  >
    <CmsImage
      src={imageUrl}
      alt={imageAlt}
      width={629}
      height={401}
      sizes={{ _: '100vw', md: 272 }}
      className={classNames(
        'h-[90px] w-full md:h-auto md:aspect-[629/401]',
        imageFit === 'contain' ? 'object-contain' : 'object-cover',
      )}
    />
  </div>
);
